import { useEffect, useState } from 'react';
import { fetchAuthConfig, type AuthConfig } from '../lib/api.js';
import { useT } from '../i18n/index.js';

export function Login({ offline }: { offline: boolean }) {
  const t = useT();
  const [cfg, setCfg] = useState<AuthConfig | null>(null);
  useEffect(() => {
    fetchAuthConfig().then(setCfg).catch(() => setCfg(null));
  }, []);
  return (
    <div className="flex h-full items-center justify-center p-6">
      <div className="w-full max-w-sm rounded-2xl border border-line bg-paper p-8 text-center shadow-sm">
        <img src="/icon.svg" alt="" className="mx-auto h-12 w-12 rounded-xl" />
        <h1 className="mt-4 text-lg font-semibold">{t('app.title')}</h1>
        <p className="mt-1 text-sm text-muted">{t('login.lead')}</p>
        <a href="/api/auth/login" className="btn btn-primary mt-6 w-full justify-center">
          {cfg?.devLogin ? t('login.dev') : t('login.google')}
        </a>
        {cfg?.mock && <p className="mt-3 text-xs text-muted">{t('login.mock')}</p>}
        {offline && <p className="mt-3 text-xs text-danger">{t('login.offline')}</p>}
      </div>
    </div>
  );
}
